import { useMemo } from "react";
import { useQuery } from "react-query";

import { Collection, getCollections } from "@/api/content.ts";
import { filterUnsupportedItems } from "@/utils";

export const useCollections = ({ ids }: { ids: number[] }) => {
  const query = useQuery(
    ["collections", ids.join(",")],
    () => {
      return getCollections(ids);
    },
    { enabled: ids && ids.length > 0 },
  );

  const collectionById = useMemo(() => {
    if (!ids || ids.length === 0) {
      return {} as Record<number, Collection>;
    }
    if (!query.data) {
      return undefined;
    }

    const collectionsById: Record<number, Collection> = {};
    for (const collection of query.data) {
      collectionsById[collection.TabId] = {
        ...collection,
        Items: filterUnsupportedItems(collection.Items),
      };
    }
    return collectionsById;
  }, [ids, query.data]);

  return { ...query, collectionById, collections: query.data };
};
